export const getPageFingerprint = () => {
  const { pathname } = window.location;

  switch (true) {
    case /product/.test(pathname):
      return 'product-page';
    case /cart/.test(pathname):
      return 'cart-page';
    case /checkout/.test(pathname):
      return 'checkout-page';
    default:
      return pathname;
  }
};
